import {isDevelopment} from '../../../config/webpack.environment';

export class YandexMetrika {

    track(code, eventCode) {
        try {
            if (typeof window.ym != 'undefined') {
                window.ym(911423, code, eventCode);
            }
        } catch (e) {
            if (isDevelopment) {
                console.log('Ошибка ' + e.name + ':' + e.message + '\n' + e.stack)
            }
        }
    }

    timeClient() {
        this.track('reachGoal', 'time_more_than_x');
    }

    /**
     *  вот эта тема не работает, так как яндекс либа не успевала загружаться
     *  по этому вставили этот метод сразу в сенькю пейд в футер
     */
    orderComplete() {
        this.track('reachGoal', 'order_complete');
    }

    notFountPage(){
        this.track('reachGoal', 'mn_error_404')
    }

    userAuthorized(user) {
        let userParams = {userId: user.USER_ID};
        this.track('userParams', userParams);
        this.track('params', userParams);
        this.track('setUserID', user.USER_ID);
    }
}


// WEBPACK FOOTER //
// ./modules/tracker/yandex-metrika.js